var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "login" }, [
    _c(
      "div",
      { staticClass: "login__content" },
      [
        _c(
          "router-link",
          {
            staticClass: "logo",
            attrs: { to: { name: "home" }, title: _vm.$t("nav.logo") },
          },
          [
            _c("img", {
              attrs: {
                src: "/assets/img/as-logo-color.svg",
                alt: _vm.$t("nav.logo"),
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("h1", [_vm._v(_vm._s(_vm.$t("nav.logo")))]),
        _vm._v(" "),
        _c(
          "form",
          {
            attrs: { action: "", method: "POST", novalidation: "" },
            on: { submit: _vm.onSubmitLoginForm },
          },
          [
            _vm.loginError !== null
              ? [
                  _c(
                    "div",
                    { staticClass: "form-message form-message--error" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.loginError) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group",
                class: {
                  "form-group--error": _vm.$v.loginObject.username.$error,
                },
              },
              [
                _c("label", { attrs: { for: "form-field-username" } }, [
                  _vm._v(_vm._s(_vm.$t("form.email"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.loginObject.username.$model,
                      expression: "$v.loginObject.username.$model",
                    },
                  ],
                  attrs: {
                    type: "text",
                    id: "form-field-username",
                    name: "username",
                  },
                  domProps: { value: _vm.$v.loginObject.username.$model },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.$v.loginObject.username,
                        "$model",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group",
                class: {
                  "form-group--error": _vm.$v.loginObject.password.$error,
                },
              },
              [
                _c("label", { attrs: { for: "form-field-password" } }, [
                  _vm._v(_vm._s(_vm.$t("form.password"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.loginObject.password.$model,
                      expression: "$v.loginObject.password.$model",
                    },
                  ],
                  attrs: {
                    type: "password",
                    id: "form-field-password",
                    name: "password",
                  },
                  domProps: { value: _vm.$v.loginObject.password.$model },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.$v.loginObject.password,
                        "$model",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "button",
                {
                  staticClass: "button primary",
                  attrs: {
                    role: "button",
                    type: "submit",
                    title: _vm.$t("form.login.submit"),
                    disabled: _vm.loginStatus,
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("form.login.submit")) +
                      "\n                "
                  ),
                ]
              ),
            ]),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button--toggle-password",
            attrs: { role: "button", title: _vm.$t("login.forgot_password") },
            on: { click: _vm.onTogglePasswordForm },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("login.forgot_password")) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "form",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showPassword,
                expression: "showPassword",
              },
            ],
            attrs: { action: "", method: "POST", novalidation: "" },
            on: { submit: _vm.onSubmitPasswordForm },
          },
          [
            _vm.passwordError !== null
              ? [
                  _c(
                    "div",
                    { staticClass: "form-message form-message--error" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.passwordError) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.passwordSuccess !== null
              ? [
                  _c(
                    "div",
                    { staticClass: "form-message form-message--success" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.passwordSuccess) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group",
                class: {
                  "form-group--error": _vm.$v.passwordObject.email.$error,
                },
              },
              [
                _c("label", { attrs: { for: "form-field-email" } }, [
                  _vm._v(_vm._s(_vm.$t("form.email"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.passwordObject.email.$model,
                      expression: "$v.passwordObject.email.$model",
                    },
                  ],
                  attrs: {
                    type: "text",
                    id: "form-field-email",
                    name: "email",
                  },
                  domProps: { value: _vm.$v.passwordObject.email.$model },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.$v.passwordObject.email,
                        "$model",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "button",
                {
                  staticClass: "button primary",
                  attrs: {
                    role: "button",
                    type: "submit",
                    title: _vm.$t("form.forgot_password.submit"),
                    disabled: _vm.passwordStatus,
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("form.forgot_password.submit")) +
                      "\n                "
                  ),
                ]
              ),
            ]),
          ],
          2
        ),
        _vm._v(" "),
        _vm._m(0),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", {
      staticClass: "login__image",
      staticStyle: {
        "background-image": "url('/assets/img/login-bkg-26082019.jpg')",
      },
    }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("footer", { staticClass: "u-extra-medium-margin--top" }, [
      _c(
        "a",
        {
          staticClass: "button--toggle-password",
          attrs: { href: "https://www.as-asphaltbau.de/impressum" },
        },
        [_vm._v("Impressum")]
      ),
      _vm._v(" |  "),
      _c(
        "a",
        {
          staticClass: "button--toggle-password",
          attrs: { href: "https://www.as-asphaltbau.de/datenschutzerklaerung" },
        },
        [_vm._v("Datenschutzerklärung")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }